function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.531 7.33A.9.9 0 0116.67 8.47l-1.908 5.724a.9.9 0 01-.57.569L8.47 16.67A.9.9 0 017.33 15.53l1.908-5.724a.9.9 0 01.57-.569L15.53 7.33zm-4.727 3.474l-1.197 3.589 3.59-1.197 1.196-3.589-3.59 1.197zM12 21.9c-5.468 0-9.9-4.432-9.9-9.9S6.532 2.1 12 2.1s9.9 4.432 9.9 9.9-4.432 9.9-9.9 9.9zm0-1.8a8.1 8.1 0 100-16.2 8.1 8.1 0 000 16.2z"
});

var SvgBrowserSafari = function SvgBrowserSafari(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/browser-safari.38c94f7c.svg";
export { SvgBrowserSafari as ReactComponent };